module.exports = __webpack_public_path__ + "static/media/img-entregues-pqdosprincipes-02.9aa384dd.jpg";